/* Secondary navigation for the faculty-only workspace pages. */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";

function FacultySectionNav() {
  const location = useLocation();
  // Legacy routes still point at the same feature areas during the transition.
  const isCourses = location.pathname === "/dashboard" || location.pathname === "/faculty/courses" || location.pathname === "/addcourse";
  const isReview = location.pathname === "/faculty/review" || location.pathname === "/faculty/history" || location.pathname === "/history";
  const isInsights = location.pathname === "/faculty/insights" || location.pathname === "/insights";
  const isUploads = location.pathname === "/faculty/uploads";

  return (
    <div className="faculty-section-nav" role="tablist" aria-label="Faculty sections">
      <NavLink to="/dashboard" className={`faculty-section-link ${isCourses ? "active" : ""}`}>
        My Courses
      </NavLink>
      <NavLink to="/faculty/uploads" className={`faculty-section-link ${isUploads ? "active" : ""}`}>
        Content
      </NavLink>
      <NavLink to="/faculty/review" className={`faculty-section-link ${isReview ? "active" : ""}`}>
        Sessions
      </NavLink>
      <NavLink to="/faculty/insights" className={`faculty-section-link ${isInsights ? "active" : ""}`}>
        Insights
      </NavLink>
    </div>
  );
}

export default FacultySectionNav;
